/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warrantyGlass': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _fill="#FFF" fill-rule="evenodd"><rect pid="0" width="11.294" height="11.294" rx=".706"/><rect pid="1" y="12.706" width="11.294" height="11.294" rx=".706"/><rect pid="2" x="12.706" width="11.294" height="11.294" rx=".706"/><rect pid="3" x="12.706" y="12.706" width="11.294" height="11.294" rx=".706"/></g>'
  }
})
